import { render } from "./ExamRuleView.vue?vue&type=template&id=150de02a&scoped=true"
import script from "./ExamRuleView.vue?vue&type=script&lang=js"
export * from "./ExamRuleView.vue?vue&type=script&lang=js"

import "./ExamRuleView.vue?vue&type=style&index=0&id=150de02a&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\police-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150de02a"]])

export default __exports__